<template>
    <div class="cp-project-list">
        <div class="teq-container">
            <div class="filters">
                <teq-custom-select v-for="(filter, index) in projectFilters.filters"
                               :name="filter.name"                              
                               :key="index"
                               v-model="filters[filter.name]"
                               :options="filter.list"
                               :option-keys="['value', 'label']"
                               @input="resultChange"
                               placeholderOption = 'true'
                               :selectedValue="selectedValueFor(filter.name)"
                >
                    <option slot="additionalOption" class="disabled" value="" selected disabled >{{ filter.title }}</option>
                </teq-custom-select>
            </div>

            <div v-if="loading" class="loader"></div>
            <div v-if="! results" class="no-results-msg">{{ dataProject.error_msg }}</div>

            <div v-if="dataProject" class="results">
                <template v-for="(projects, chunkedIndex) in chunkedList">
                    <div class="clearfix">
                        <div class="item" v-for="(project, index) in projects" :key="index" >
                            <img class="illust" :src="project.url_img" :alt="project.alt_img"/>
                            <div class="-content">
                                <div class="subtitle">{{ project.subtitle }}</div>
                                <div class="title">{{ project.title }}</div>

                                <div class="hidden">
                                    <div class="structure">{{ project.structure }}</div>
                                    <div class="city">{{ project.city }}</div>
                                </div>
                            </div>
                            <a class="link" :href="project.url_project"></a>
                        </div>
                    </div >
                </template>
            </div>
            <paginate
                v-if="dataProject"
                v-model="page"
                :page-count="dataProject.page_total"
                :page-range="3"
                :click-handler="clickCallback"
                :prev-text="''"
                :next-text="''"
                :prev-link-class="'prev'"
                :next-link-class="'next'"
                :container-class="'pagination'"
                :page-class="'page-item'">
            </paginate>
        </div>
    </div>
</template>

<script>
    import collect from 'collect.js'
    import qs from 'qs';
    import axios from 'axios';
    import Paginate from 'vuejs-paginate'
    import TeqCustomSelect from 'teq-custom-select'
    import { chunk } from '../utils/functions'

    const isLast = (index, arr) => index === arr.length - 1;

    const formatFiltersForQuery = filters => collect(filters).mapWithKeys(filter => [filter.name, filter.value])

    export default {
        components: {
            TeqCustomSelect,
            Paginate
        },
        props: {
            ajaxUrl: {
                required: true
            },
            projectFilters: {
                required: true,
            },
            themeId: {
                type: Number,
                required: false,
                default: null,
            },

        },
        data() {
            return {
                dataProject: null,
                filters: {},
                loading: true,
                results: true,
                page: 1,
            }
        },
        computed: {
            chunkedList() {
                return chunk(this.dataProject.list, 3)
            }
        },

        created() {
            if (this.themeId) {
                this.filters['themes'] = {
                    name: 'themes',
                    value: this.themeId,
                }
            }
        },

        mounted() {
            this.resultChange();
        },

        methods: {
            selectedValueFor(filterName) {
                if (! this.filters[filterName]) {
                    return null;
                }

                return this.filters[filterName].value
            },
            async resultChange(){
                this.showLoader();

                const data = {
                    ...formatFiltersForQuery(this.filters).all(),
                    page: this.page,
                    postsPerPage: 6,
                };

                try {
                    const response = await axios.get(this.ajaxUrl, {
                        params: data,
                        paramsSerializer: params => {
                            return qs.stringify(params)
                        }
                    });
                    this.dataProject = response.data;
                    this.results = !! this.dataProject.list.length;
                } catch (error) {
                    console.log(error);
                }

                this.hideLoader();

            },

            showLoader() {
                this.loading = true;
            },

            hideLoader() {
                this.loading = false;
            },

            isLast(index) {
                return isLast(index, this.projectFilters.list)
            },

            clickCallback(pageNum) {
                this.page = pageNum;
                this.resultChange();
            }
        }
    }
</script>
